import { IContaContato } from "../../../../Interfaces/Geral/Contatos/ContaContato/ContaContatoInterfaces";
import { IContatos } from "../../../../Interfaces/Geral/Contatos/ContatosInterfaces";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export async function VincularContaContatoService(requestBody: IContaContato) {
    return Service(
        Axios.post("/home/contacontato/vincularcontacontato", requestBody)
    );
}

export async function ListarContatoNaoVinculadoService(
    DS_CONTATO: string,
    idConta: number
) {
    return Service(
        Axios.post<Array<IContatos>>(
            `/home/contacontato/listarcontatonaovinculados?DS_CONTATO=${DS_CONTATO}&IDConta=${idConta}`
        )
    );
}
